var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { useListContext, useNotify, useRefresh } from "react-admin";
import { PageHeaderStyles } from "../../components/styles/PageHeaderStyles";
import ElectionHeader from "../../components/ElectionHeader";
import { useTranslation } from "react-i18next";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Checkbox from "@mui/material/Checkbox";
import { IPermissions } from "../../types/keycloak";
import { TextField } from "@mui/material";
import { useMutation } from "@apollo/client";
import { DELETE_ROLE_PERMISSION } from "@/queries/DeleteRolePermission";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { SET_ROLE_PERMISSION } from "@/queries/SetRolePermission";
import { AuthContext } from "@/providers/AuthContextProvider";
import { canEditRolePermission, rolePermissionEdit } from "@/services/RolePermissionEdit";
export function getEnumValues(enumObject) {
    return Object.keys(enumObject)
        .filter(function (key) { return Number.isNaN(Number(key)); })
        .map(function (key) { return enumObject[key]; });
}
export var EditRole = function (_a) {
    var id = _a.id, close = _a.close, permissions = _a.permissions;
    var _b = useListContext(), data = _b.data, isLoading = _b.isLoading;
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var deleteRolePermission = useMutation(DELETE_ROLE_PERMISSION)[0];
    var setRolePermission = useMutation(SET_ROLE_PERMISSION)[0];
    var notify = useNotify();
    var refresh = useRefresh();
    var authContext = useContext(AuthContext);
    var edit = rolePermissionEdit(function (permission) {
        return authContext.isAuthorized(true, tenantId, permission);
    });
    if (isLoading || !data) {
        return null;
    }
    var role = data === null || data === void 0 ? void 0 : data.find(function (element) { return element.id === id; });
    var rolePermissions = (role === null || role === void 0 ? void 0 : role.permissions) || [];
    var validPermissions = getEnumValues(IPermissions);
    var rows = (permissions || [])
        .filter(function (permission) { return permission.name && validPermissions.includes(permission.name); })
        .map(function (permission) { return (__assign(__assign({}, permission), { id: permission.id || "", name: permission.name && t("usersAndRolesScreen.permissions.".concat(permission.name)), active: (!!permission.name && rolePermissions.includes(permission.name)) || false, editable: !!permission.name && canEditRolePermission(edit, permission.name) })); });
    var editRolePermission = function (props) { return function () { return __awaiter(void 0, void 0, void 0, function () {
        var permission, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    permission = (permissions || []).find(function (el) { return el.id === props.row.id; });
                    console.log(permission);
                    if (!(permission === null || permission === void 0 ? void 0 : permission.name) || !role) {
                        return [2 /*return*/];
                    }
                    console.log(permission.name);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (props.value ? deleteRolePermission : setRolePermission)({
                            variables: {
                                tenantId: tenantId,
                                roleId: role.id,
                                permissionName: permission.name,
                            },
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    notify(t("usersAndRolesScreen.roles.notifications.permissionEditError"), {
                        type: "error",
                    });
                    console.log("Error editing permission: ".concat(error_1));
                    return [2 /*return*/];
                case 4:
                    notify(t("usersAndRolesScreen.roles.notifications.permissionEditSuccess"), {
                        type: "success",
                    });
                    refresh();
                    return [2 /*return*/];
            }
        });
    }); }; };
    var columns = [
        {
            field: "name",
            headerName: "Permission",
            width: 350,
            editable: false,
        },
        {
            field: "active",
            headerName: "Active",
            width: 70,
            editable: false,
            renderCell: function (props) { return (_jsx(Checkbox, { checked: props.value, disabled: !props.row.editable, onClick: editRolePermission(props) })); },
        },
    ];
    return (_jsxs(PageHeaderStyles.Wrapper, { children: [_jsx(ElectionHeader, { title: String(t("usersAndRolesScreen.roles.edit.title")), subtitle: "usersAndRolesScreen.roles.edit.subtitle" }), _jsx(TextField, { label: "Name", value: role === null || role === void 0 ? void 0 : role.name, InputProps: {
                    readOnly: true,
                } }), _jsx(DataGrid, { rows: rows, columns: columns, initialState: {
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }, pageSizeOptions: [10, 20, 50, 100], disableColumnFilter: true, disableColumnSelector: true, disableDensitySelector: true, showToolbar: true, slots: { toolbar: GridToolbar }, slotProps: {
                    toolbar: {
                        showQuickFilter: true,
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                    },
                } })] }));
};
